import { useQuery } from '@tanstack/react-query';

import { getDealsBoardQueryOptions } from '@crm/entities/deals-board';

export const useGetDealsBoardQuery = () => useQuery(getDealsBoardQueryOptions());
